import { Hint } from "@/components/ui/hint";
import { cn } from "@/lib/utils";
import { ReadShiftReportDepartmentEntry } from "@/types/shiftReportDepartmentEntry";
import { Row } from "@tanstack/react-table";
import { TriangleAlert } from "lucide-react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { hasEntryEnoughEmployees } from "../utils/hasEntryEnoughEmployees";

interface ShiftReportEditorEntryWarningProps {
  row: Row<ReadShiftReportDepartmentEntry>;
}

const ShiftReportEditorEntryWarning = ({
  row,
}: ShiftReportEditorEntryWarningProps) => {
  const { t } = useTranslation();
  const entry = useWatch({
    name: `department_entries.${row.index}`,
  });
  const error = !hasEntryEnoughEmployees(entry);

  if (error) {
    return (
      <Hint
        icon={TriangleAlert}
        className={cn("truncate whitespace-nowrap", {
          "text-orange-600": error,
        })}
        classNameText="truncate"
      >
        {t("shiftReports.entry.warning")}
      </Hint>
    );
  }
  return null;
};

export default ShiftReportEditorEntryWarning;
